export default __webpack_public_path__ + "static/media/vnpt_footer_banner.bd2b591e.jpg";